import type { ListCounterType } from '@worldathletics/types';

import { useReferenceMap } from '@/context/references/references-context';
import { resolveRefTokens } from '@/lib/resolve-ref-tokens';
import { sanitizeBlockHtml } from '@/lib/sanitize';
import { HtmlContent } from '@/components/atoms/html-content/html-content';
import type { DocumentEntity } from '@/context/store/slices/documentDataSlice';

import './document-view-list.scss';

const COUNTER_TYPE_TO_CSS: Record<ListCounterType, string> = {
  numeric: 'decimal',
  'lower-alpha': 'lower-alpha',
  'upper-alpha': 'upper-alpha',
  'lower-roman': 'lower-roman',
  'upper-roman': 'upper-roman',
};

type Props = { node: DocumentEntity & { type: 'list' } };

function DocumentViewList({ node }: Props) {
  const refMap = useReferenceMap();
  const Tag = node.style === 'ordered' ? 'ol' : 'ul';
  const start = node.meta?.start;
  const counterType = node.meta?.counterType;

  return (
    <div id={node.id} data-type="card" className={`doc-view-list is-${node.style}`}>
      <Tag
        className="doc-view-list__list"
        {...(node.style === 'ordered' && start !== undefined ? { start } : {})}
        style={
          node.style === 'ordered' && counterType
            ? { listStyleType: COUNTER_TYPE_TO_CSS[counterType] }
            : undefined
        }
      >
        {node.items.map((item, index) => (
          <li key={index} className="doc-view-list__item">
            <HtmlContent
              as="span"
              html={sanitizeBlockHtml(resolveRefTokens(item, refMap, node.id))}
            />
          </li>
        ))}
      </Tag>
    </div>
  );
}

export { DocumentViewList };
